import React, { Component } from "react";
import { Growl } from "primereact/growl";
import Spinner from "../../Common/Spinner";
import "react-datepicker/dist/react-datepicker.css";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import addMonths from "date-fns/addMonths";
import subMonths from "date-fns/subMonths";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import { Messages } from "primereact/messages";
import * as appConst from "../../Common/constants";
import { Dropdown } from "primereact/dropdown";

class LedgerAddEdit extends Component {
  constructor(props) {
    super(props);

    var _txnDate, _txnType, _amount, _mode;
    if (this.props.pData._id == "NA") {
      _txnDate = "";
      _txnType = "";
      _amount = 0.0;
      _mode = "add";
    } else {
      _amount =
        this.props.pData.amount < 0
          ? this.props.pData.amount * -1
          : this.props.pData.amount;
      _txnType = this.props.pData.txnType;
      _mode = "edit";
    }

    this.state = {
      txndate: _txnDate,
      txnType: _txnType,
      amount: _amount,
      spinnerClass: "collapse",
      dataClass: "",
      mode: _mode,
      bankName: "",
      txnTypes: [
        { label: "Deposit", value: "Deposit" },
        { label: "Withdraw", value: "Withdraw" }
      ]
    };

    this.handleTxnDateChange = this.handleTxnDateChange.bind(this);
  }

  componentDidMount() {
    this.LoadBankName();
  }

  LoadBankName() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/Bank/getBankName/" +
          this.props.bank
      )
      .then(response => {
        this.setState({ bankName: response.data });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  render() {
    return (
      <div>
        <div className="bg-success text-white p-1">
          <h4 align="center">{this.state.bankName}</h4>
        </div>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid">
            <div className={this.getTxnDateClass()}>
              <div className="col col-md-2">Txn Date</div>
              <div className="col col-md-3">
                <DatePicker
                  selected={this.state.txndate}
                  onChange={this.handleTxnDateChange}
                  dateFormatCalendar={"MMM yyyy"}
                  minDate={subMonths(new Date(), 10)}
                  maxDate={new Date()}
                  showMonthYearDropdown
                  dateFormat="dd-MMM-yyyy"
                  width="300px"
                  // style={{ width: "300px" }}
                  className="p-error"
                />
              </div>
            </div>

            <div className="row p-1 border">
              <div className="col col-md-2">Txn Type</div>
              <div className="col col-md-3">
                <Dropdown
                  value={this.state.txnType}
                  options={this.state.txnTypes}
                  placeholder="Select"
                  onChange={e => this.setState({ txnType: e.target.value })}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2"> Amount</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  keyfilter="money"
                  value={this.state.amount}
                  onChange={e => this.setState({ amount: e.target.value })}
                  style={{ width: "300px" }}
                  className="p-error"
                />
              </div>
            </div>
            <div className="row p-1 border">
              <button
                onClick={this.onSaveClick}
                className="btn btn-primary btn-md mr-2"
              >
                Save
              </button>
              <button
                onClick={this.onClearClick}
                className="btn btn-primary btn-md mr-2"
              >
                Clear
              </button>
              <button
                onClick={this.onCancelClick}
                className={this.getCancelClass()}
              >
                Cancel
              </button>
            </div>
            <Growl ref={el => (this.growl = el)} />
            <Messages ref={el => (this.messages = el)} />
          </div>
        </div>
      </div>
    );
  }

  getCancelClass() {
    let clsName = "btn btn-primary btn-md mr-2 ";
    if (this.props.source === "list") {
      clsName += "visible";
    } else {
      clsName += "invisible";
    }
    return clsName;
  }

  getTxnDateClass() {
    let clsName = "row p-1 border ";
    if (this.props.pData._id != "NA") clsName += "collapse";

    return clsName;
  }

  handleTxnDateChange(txndate) {
    this.setState({ txndate });
  }

  onSaveClick = e => {
    e.preventDefault();
    if (
      this.state.txndate === "" ||
      this.state.amount === 0.0 ||
      this.state.txnType === ""
    ) {
      this.messages.show({
        severity: "error",
        summary: "Error !!",
        detail: "Enter Mandatory Fields"
      });
    } else {
      const obj = {
        txnDate: this.state.txndate,
        txnType: this.state.txnType,
        amount: this.state.amount,
        bno: this.props.bank
      };

      if (this.state.txnType === "Withdraw") obj.amount *= -1;

      if (this.state.mode === "add") {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
              
              "/bankLedger/add",
            obj
          )
          .then(res => console.log(res.data));
        this.ClearData();
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Ledger Added !!!"
        });
      } else {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
              
              "/bankLedger/update/" +
              this.props.pData._id,
            obj
          )
          .then(res => {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "Ledger Updated !!!"
            });
            this.props.onClick("List", null);
          });
      }
    }
  };

  ClearData() {
    this.setState({ txndate: "", txnType: "", amount: 0 });
  }

  onClearClick = e => {
    this.ClearData();
    this.growl.show({
      severity: "success",
      summary: "Success",
      detail: "Data Cleared !!!"
    });
  };

  onCancelClick = e => {
    this.props.onClick("List", null);
  };
}

export default LedgerAddEdit;
